// Industry options for the business Category dropdown.
export const INDUSTRIES = [
  "Automotive",
  "Beauty & Spa",
  "Cleaning Services",
  "Construction & Contractors",
  "Dental",
  "Education & Tutoring",
  "Events & Weddings",
  "Financial Services",
  "Fitness & Gyms",
  "Food & Restaurant",
  "Health & Medical",
  "Home Services (HVAC, Plumbing, Electrical)",
  "Hotels & Travel",
  "Insurance",
  "Legal Services",
  "Marketing & Design",
  "Nonprofit & Community",
  "Pet Services",
  "Photography & Video",
  "Real Estate",
  "Retail & Shopping",
  "Salon & Barber",
  "Technology & IT",
  "Veterinary",
];
